import { useEffect, useState } from "react";

export function useDebouncedValue<T>(value: T, timeout: number) {
	const [debouncedValue, setDebouncedValue] = useState(value);

	/** Effects */
	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, timeout);

		return () => {
			clearTimeout(handler);
		};
	}, [value, timeout]);

	return debouncedValue;
}
